<template>
  <my-header v-if="!hideHeader"></my-header>
  <router-view></router-view>
  <my-footer v-if="!hideFooter"></my-footer>
</template>

<script>
import Header from "./components/layouts/header.vue";
import Footer from "./components/layouts/footer.vue";

export default {
  name: "App",
  components: {
    "my-header": Header,
    "my-footer": Footer,
  },
  data() {
    return {
      hideHeader: true, // Set to true to hide header for Resources component
      hideFooter: true, // Set to true to hide footer for Resources component
    };
  },
  watch: {
    $route(to) {
      const hideForRoutes = [
        "Corporate Resources",
        "Tarana Resources",
        "Operators",
        "Verify SSO",
        "Resource Redirect",
        "Resource Doc",
      ]; // Add routes requiring hidden header/footer
      this.hideHeader = hideForRoutes.includes(to.name);
      this.hideFooter = hideForRoutes.includes(to.name);
    },
  },
  mounted() {
    // security/2.2b: the eager `/sanctum/csrf-cookie` preflight that used to
    // run here has been removed. It duplicated the handshake in
    // src/axios.js, which fetches the cookie lazily inside the request
    // interceptor on the first state-changing call and collapses concurrent
    // callers onto a single round trip.
    //
    // Duplicating it here was not merely redundant, it defeated the reason
    // the interceptor is lazy: this hook runs on every app boot, so every
    // cold load of a public page -- including the anonymous /operators
    // iframe embedded on the marketing site and the corporate resource
    // pages, none of which ever issue a mutation -- paid for a round trip
    // it did not need.
    //
    // Nothing is lost. The interceptor covers the same first-POST case
    // (login / signup / forgot) plus two the preflight never did: it
    // re-handshakes when the cookie has expired past SESSION_LIFETIME, and
    // the response interceptor retries once on a 419. See
    // src/tests/unit/axios.csrf.spec.js for the regression coverage.
    this.identifyUserWithHubSpot();
  },
  methods: {
    async identifyUserWithHubSpot() {
      const platform = process.env.VUE_APP_PLATFORM;
      const hubspotUTK = this.getHubspotUTK();
      const user = this.$store.state.auth?.user;
      const identifyPayload = {};

      // Retrieve user email from URL or store
      let userEmail = this.getUserEmailFromUrl() || (user?.user?.email ?? "");

      // Add email and HubSpot UTK to payload if available

      if (hubspotUTK) {
        identifyPayload.hubspotutk = hubspotUTK;
      }

      if (userEmail) {
        identifyPayload.email = decodeURIComponent(userEmail);
      }

      if (platform === "production" && identifyPayload.email) {
        window._hsq = window._hsq || [];
        window._hsq.push(["identify", identifyPayload]);
        window._hsq.push(["trackPageView"]);
      }
    },
    getHubspotUTK() {
      const cookies = document.cookie.split(";");
      for (let cookie of cookies) {
        const [key, value] = cookie.trim().split("=");
        if (key === "hubspotutk") {
          return value;
        }
      }
      return null; // Return null if not found
    },
    getHubSpotUTKFromUrl() {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get("hubspotutk");
      } catch (error) {
        return null;
      }
    },
    getUserEmailFromUrl() {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get("user_email");
      } catch (error) {
        return null;
      }
    },
  },
};
</script>
